import Api from '../resources/Api';

const defaultData = {
  settings: {
    contract_allows_credit_card: null,
    contract_allows_boleto: null,
    contract_enable_method: null,
    contract_allows_manual_credit_card: null,
    contract_allows_enable_canceled_contract: null,
    payment_boleto_gateway_provider: null,
    contract_show_checkout_link: null,
    payment_extra_gateways: []
  }
};

const data = {
  namespaced: true,
  state: {
    settings: defaultData.settings
  },

  mutations: {
    updateSettings: (state, settings) => {
      // if (settings.payment_extra_gateways != null) {
      //   settings.payment_extra_gateways = JSON.parse(
      //     settings.payment_extra_gateways
      //   );
      // }
      state.settings = Object.assign(state.settings, settings);
    }
  },

  getters: {
    paymentMethods: state => {
      const extraGateways = state.settings.payment_extra_gateways || [];
      const fixedGateways = [
        {
          name: 'card_pagar_me',
          description: 'Cartão - PagarMe',
          is_card: true
        },
        {
          name: 'ticket_pagar_me',
          description: 'Boleto - PagarMe',
          is_card: false
        }
      ];

      const gateways = fixedGateways.concat(extraGateways);
      return _.sortBy(gateways, 'description');
    }
  },

  actions: {
    async getSettings(context) {
      const result = await Api.settings.public();
      context.commit('updateSettings', result.data.settings);
    }
  }
};

export default data;
